import React, { useState, useEffect } from "react";
import TopBar from "./TopBar";
import AddNewPostModal from "./AddNewPostModal";

function CreatorGallery() {
  const [isOpen, setIsOpen] = useState(false);

  const openAddNewPostModal = () => setIsOpen(true);

  return (
    <>
      <AddNewPostModal isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="bg h-full min-h-screen">
        <TopBar />

        <div
          className="fixed bottom-5 right-5 md:bottom-10 text-xs md:text-base md:right-10 p-2.5 hover:shadow-2xl text-white font-semibold bg-blue-500 rounded-lg shadow-md transition duration-700 hover:cursor-pointer"
          onClick={openAddNewPostModal}
        >
          Post New Content
        </div>
      </div>
    </>
  );
}

export default CreatorGallery;
